<template>
  <div class="comment">
    <div class="comment__header">
      <h2 class="comment__title">
        {{ title }}
      </h2>
      <span
        v-if="date"
        class="comment__date"
      >{{ date }}</span>
      <span class="comment__actions">
        <v-button
          v-if="isDeleteAction"
          color="transparent"
          @click="$emit('deleteItem')"
        >
          <v-icon type="trash" />
        </v-button>
        <v-button
          v-if="isEditAction"
          color="transparent"
          @click="$emit('editItem')"
        >
          <v-icon type="edit" />
        </v-button>
      </span>
    </div>
    <slot />
  </div>
</template>

<script>
  import Button from "@/atoms/Button";
  import Icon from "@/atoms/Icon";
  export default {
    components: {
      "v-button": Button,
      "v-icon": Icon
    },
    props: {
      title: {
        type: String,
        default: null,
        required: true
      },
      date: {
        type: String,
        default: null
      },
      isEditAction: {
        type: Boolean,
        default: true,
        required: false
      },
      isDeleteAction: {
        type: Boolean,
        default: true,
        required: false
      }
    }
  };
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
	.comment {
		padding-top: 1rem;
		padding-bottom: 1rem;
		border-bottom: solid 1px $zircon;
		color: $kashmir;
		&__header {
			margin-bottom: 1rem;
			display: flex;
			align-items: center;
		}
		&__title {
			color: $tangaroa;
			margin-bottom: 0;
		}
		&__date {
			color: $stone;
			margin-left: 1rem;
		}
		&__actions {
			margin-left: auto;
		}
	}
</style>
